{
    "pagination": {
        "previous": "&laquo; Previous",
        "next": "Next &raquo;"
    },
    "pageHeader": {
        "nav": {
            "close": "Close",
            "open": "Menu"
        },
        "closed": "Closed",
        "openingHoursToday": "Open today",
        "search": {
            "buttonLabel": "Search",
            "close": "Close",
            "heading": "Search",
            "inputPlaceholder": "What are you looking for?",
            "open": "Search"
        }
    },
    "ticketing": {
        "loading": "Loading",
        "date": {
            "select": "Select date",
            "selected": "Selected date",
            "yourSelection": "You have selected",
            "redoSelection": "Pick another date"
        },
        "slot": {
            "select": "Select time",
            "selected": "Selected time",
            "selectDifferent": "Select another time",
            "full": "No tickets available"
        },
        "product": {
            "minimumSelection": "Pick atleast one product",
            "moreInfo": "More information",
            "pricePrefix": "Kr",
            "each": "pcs.",
            "quantity": {
                "decrease": "Decrease number",
                "increase": "Increase number"
            }
        },
        "cart": {
            "add": "Add to cart",
            "adding": "Adding to cart"
        },
        "summary": {
            "total": "Total",
            "willBeAddedToCart": "The following products will be added to your cart",
            "empty": "The cart is empty",
            "removeItem": "Remove product"
        }
    },
    "webshop": {
        "cart": {
            "add": "Add to cart",
            "checkout": "Checkout",
            "close": "Close",
            "heading": "Cart",
            "loading": "Loading",
            "open": "Open cart",
            "removeItem": "Remove item",
            "total": "Total"
        },
        "quantity": {
            "decrease": "Decrease quantity",
            "increase": "Increase quantity"
        },
        "discountSelector": {
            "selectDiscountCode": "Select discount code",
            "selectOrEnterDiscountCode": "Select or enter discount code",
            "enterDiscountCode": "I want to enter my own discount code",
            "discountCode": "Discount code | Discount codes",
            "youSave": "You save NOK {amount}",
            "useCode": "Use code",
            "invalidCode": "The code is invalid"
        },
        "giftCardBuilder": {
            "amount": "Amount",
            "customAmount": "Custom amount",
            "amountSuffix": "NOK",
            "message": "Message",
            "messageHelpText": "Optional, up to {maxChars} characters",
            "messageTooManyLines": "The message contains too many lines",
            "giftCard": "Gift card",
            "validTo": "Valid to",
            "qrCode": "QR-code",
            "code": "Code",
            "placeholderTheme": {
                "name": "Loading...",
                "headline": "Gift Card"
            }
        }
    },
    "mer": {
        "levels": {
            "1": "Very easy",
            "2": "Easy",
            "3": "Normal",
            "4": "Difficult",
            "5": "Very difficult"
        },
        "filters": {
            "heading": "Filters",
            "subject": "Activity",
            "theme": "Theme",
            "level": "Difficulty"
        },
        "noActivities": "We could not find any activities. Try changing the filters.",
    },
    "carousel": {
        "previous": "Previous",
        "next": "Next"
    },
    "program": {
        "loading": "Loading...",
        "time": "Time",
        "duration": "Duration",
        "price": "Price",
        "showMoreDays": "Show more days",
        "filterAndDate": "Filter and date",
        "date": "Date",
        "all": "All",
        "suitableFor": "Suitable for",
        "type": "Type",
        "selectDate": "Select date",
        "dayHeader": {
            "title": "Program",
            "open": "Open",
            "closed": "Closed",
            "explore": "Explore the exhibition",
            "openingHours": "Opening hours"
        },
        "highlights": "Highlights",
        "seeFullProgram": "See full program",
        "buyTickets": "Buy tickets",
        "readMore": "Read more",
        "share": "Share"
    }
}
